/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Honors_EyebrowInputs */

const en_about_honors_eyebrow = /** @type {(inputs: About_Honors_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Honors`)
};

const es_about_honors_eyebrow = /** @type {(inputs: About_Honors_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distinciones`)
};

const de_about_honors_eyebrow = /** @type {(inputs: About_Honors_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auszeichnungen`)
};

const zh_about_honors_eyebrow = /** @type {(inputs: About_Honors_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`荣誉`)
};

const ar_about_honors_eyebrow = /** @type {(inputs: About_Honors_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التكريمات`)
};

const fr_about_honors_eyebrow = /** @type {(inputs: About_Honors_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distinctions`)
};

const vi_about_honors_eyebrow = /** @type {(inputs: About_Honors_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh hiệu`)
};

const sw_about_honors_eyebrow = /** @type {(inputs: About_Honors_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heshima`)
};

const th_about_honors_eyebrow = /** @type {(inputs: About_Honors_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกียรติประวัติ`)
};

const bs_about_honors_eyebrow = /** @type {(inputs: About_Honors_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priznanja`)
};

const ja_about_honors_eyebrow = /** @type {(inputs: About_Honors_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`栄誉`)
};

const ko_about_honors_eyebrow = /** @type {(inputs: About_Honors_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수상 경력`)
};

const pt_about_honors_eyebrow = /** @type {(inputs: About_Honors_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prêmios`)
};

const it_about_honors_eyebrow = /** @type {(inputs: About_Honors_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onorificenze`)
};

const sv_about_honors_eyebrow = /** @type {(inputs: About_Honors_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utmärkelser`)
};

const nl_about_honors_eyebrow = /** @type {(inputs: About_Honors_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onderscheidingen`)
};

const da_about_honors_eyebrow = /** @type {(inputs: About_Honors_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hædersbevisninger`)
};

const nb_about_honors_eyebrow = /** @type {(inputs: About_Honors_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utmerkelser`)
};

const fi_about_honors_eyebrow = /** @type {(inputs: About_Honors_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunnianosoitukset`)
};

const pl_about_honors_eyebrow = /** @type {(inputs: About_Honors_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyróżnienia`)
};

const ru_about_honors_eyebrow = /** @type {(inputs: About_Honors_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Награды`)
};

const tr_about_honors_eyebrow = /** @type {(inputs: About_Honors_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ödüller`)
};

const hi_about_honors_eyebrow = /** @type {(inputs: About_Honors_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सम्मान`)
};

const id_about_honors_eyebrow = /** @type {(inputs: About_Honors_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kehormatan`)
};

const ms_about_honors_eyebrow = /** @type {(inputs: About_Honors_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penghormatan`)
};

const cs_about_honors_eyebrow = /** @type {(inputs: About_Honors_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocenění`)
};

const el_about_honors_eyebrow = /** @type {(inputs: About_Honors_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Διακρίσεις`)
};

const he_about_honors_eyebrow = /** @type {(inputs: About_Honors_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אותות הוקרה`)
};

const af_about_honors_eyebrow = /** @type {(inputs: About_Honors_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toekennings`)
};

const hu_about_honors_eyebrow = /** @type {(inputs: About_Honors_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kitüntetések`)
};

/**
* | output |
* | --- |
* | "Honors" |
*
* @param {About_Honors_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_honors_eyebrow = /** @type {((inputs?: About_Honors_EyebrowInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Honors_EyebrowInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_honors_eyebrow(inputs)
	if (locale === "de") return de_about_honors_eyebrow(inputs)
	if (locale === "zh") return zh_about_honors_eyebrow(inputs)
	if (locale === "ar") return ar_about_honors_eyebrow(inputs)
	if (locale === "fr") return fr_about_honors_eyebrow(inputs)
	if (locale === "vi") return vi_about_honors_eyebrow(inputs)
	if (locale === "sw") return sw_about_honors_eyebrow(inputs)
	if (locale === "th") return th_about_honors_eyebrow(inputs)
	if (locale === "bs") return bs_about_honors_eyebrow(inputs)
	if (locale === "ja") return ja_about_honors_eyebrow(inputs)
	if (locale === "ko") return ko_about_honors_eyebrow(inputs)
	if (locale === "pt") return pt_about_honors_eyebrow(inputs)
	if (locale === "it") return it_about_honors_eyebrow(inputs)
	if (locale === "sv") return sv_about_honors_eyebrow(inputs)
	if (locale === "nl") return nl_about_honors_eyebrow(inputs)
	if (locale === "da") return da_about_honors_eyebrow(inputs)
	if (locale === "nb") return nb_about_honors_eyebrow(inputs)
	if (locale === "fi") return fi_about_honors_eyebrow(inputs)
	if (locale === "pl") return pl_about_honors_eyebrow(inputs)
	if (locale === "ru") return ru_about_honors_eyebrow(inputs)
	if (locale === "tr") return tr_about_honors_eyebrow(inputs)
	if (locale === "hi") return hi_about_honors_eyebrow(inputs)
	if (locale === "id") return id_about_honors_eyebrow(inputs)
	if (locale === "ms") return ms_about_honors_eyebrow(inputs)
	if (locale === "cs") return cs_about_honors_eyebrow(inputs)
	if (locale === "el") return el_about_honors_eyebrow(inputs)
	if (locale === "he") return he_about_honors_eyebrow(inputs)
	if (locale === "af") return af_about_honors_eyebrow(inputs)
	if (locale === "hu") return hu_about_honors_eyebrow(inputs)
	return en_about_honors_eyebrow(inputs)
});